import { render, staticRenderFns } from "./StatusModalOld.vue?vue&type=template&id=6f83f95b&scoped=true&"
import script from "./StatusModalOld.vue?vue&type=script&lang=js&"
export * from "./StatusModalOld.vue?vue&type=script&lang=js&"
import style0 from "./StatusModalOld.vue?vue&type=style&index=0&id=6f83f95b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f83f95b",
  null
  
)

export default component.exports